export const SECURITY_CONFIG = {
  // Password requirements
  password: {
    minLength: 12,
    requireUppercase: true,
    requireLowercase: true,
    requireNumbers: true,
    requireSpecialChars: true,
    maxAttempts: 5,
    lockoutDuration: 15 * 60 * 1000, // 15 minutes
  },
  // Session configuration  
  session: {
    tokenExpiry: '1h',
    refreshTokenExpiry: '7d',
    inactivityTimeout: 30 * 60 * 1000, // 30 minutes
  },
  // Rate limiting
  rateLimit: {
    window: 15 * 60 * 1000, // 15 minutes
    maxRequests: 100,
    whitelistedIPs: [],
  },
  // API Security
  api: {
    maxPayloadSize: '10mb',
    allowedOrigins: [
      'https://app.sprinklenetlabs.com',
      'https://api.sprinklenetlabs.com'
    ],
    allowedMethods: ['GET', 'POST', 'PUT', 'DELETE'],
    requireHTTPS: true
  },
  // File upload restrictions
  uploads: {
    maxSize: 50 * 1024 * 1024, // 50MB
    allowedTypes: [
      'application/pdf',
      'application/msword',
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
      'text/plain',
      'text/markdown'
    ],
    scanForMalware: true
  },
  // OTP Configuration
  otp: {
    length: 6,
    expiry: 5 * 60, // 5 minutes
    maxAttempts: 3,
    resendDelay: 30, // seconds
    type: 'numeric', // 'numeric' | 'alphanumeric'
  },
  // Role-based access control
  rbac: {
    roles: {
      super_admin: {
        description: 'Sprinklenet Super Admin',
        permissions: ['*'], // All permissions
      },
      client_admin: {
        description: 'Sprinklenet Client Admin',
        permissions: [
          'view:clients',
          'manage:clients',
          'view:analytics',
          'manage:settings',
        ],
      },
      org_admin: {
        description: 'Organization Admin',
        permissions: [
          'manage:org_users',
          'manage:knowledge_spaces',
          'manage:chatbots',
          'view:analytics',
          'manage:settings',
        ],
      },
      org_member: {
        description: 'Organization Member',
        permissions: [
          'view:knowledge_spaces',
          'view:chatbots',
          'manage:assigned_spaces',
        ],
      },
    },
  },
  // Organization limits
  organization: {
    defaults: {
      knowledgeSpaces: 5,
      chatbots: 10,
      adminUsers: 2,
      memberUsers: 10,
      storage: '50GB',
    },
    maxLimits: {
      knowledgeSpaces: 100,
      chatbots: 500,
      adminUsers: 10,
      memberUsers: 1000,
      storage: '1TB',
    },
  },
}
// Sensitive data patterns to be sanitized from logs
export const SENSITIVE_DATA_PATTERNS = [
  /password/i,
  /apiKey/i,
  /secret/i,
  /token/i,
  /auth/i,
  /key/i,
  /credential/i
]
// Security headers configuration
export const SECURITY_HEADERS = {
  'Strict-Transport-Security': 'max-age=31536000; includeSubDomains',
  'X-Content-Type-Options': 'nosniff',
  'X-Frame-Options': 'SAMEORIGIN',
  'X-XSS-Protection': '1; mode=block',
  'Content-Security-Policy': "default-src 'self'; script-src 'self' 'unsafe-inline' 'unsafe-eval'; style-src 'self' 'unsafe-inline';",
  'Referrer-Policy': 'strict-origin-when-cross-origin'
}